import React, { Component } from 'react';
import { Data } from '../Data';

export class NetworkActivation extends Component {
    constructor(props) {
        super(props);
        this.dataService = new Data();
		this.performNetworkActivation = this.performNetworkActivation.bind(this);		
    }

    performNetworkActivation()
    {
        let url = window.location.search;
        console.log({ url });
;
        const arr = url.slice(1).split(/&|=/); // remove the "?", "&" and "="

        for (let i = 0; i < arr.length; i += 2) {
            const key = arr[i], value = arr[i + 1];
            if ((key === 'id') && value) {
                this.dataService.performNetworkActivation(value);
            }
        }		
	}
	
    render() {
        return (<div>{this.performNetworkActivation()}</div>)
	}
}
